import { useMemo } from "react";
import { Select, SelectContent, SelectGroup, SelectItem, SelectLabel, SelectTrigger } from "./ui/select";
import { Field } from "./Chips";
import { findItem } from "../lib/presets";

const Tag = ({ children }) => (
  <span className="shrink-0 text-[10px] uppercase tracking-wider font-semibold px-2 py-0.5 rounded-md bg-[var(--c-orange)]/15 text-[var(--c-orange)]">{children}</span>
);

const groupsOf = (items) => [...new Set(items.map((x) => x.group))];

export const ModelSelect = ({ label, items, value, onChange, testId, hint, meta }) => {
  const cur = findItem(items, value);
  const groups = useMemo(() => groupsOf(items).map((g) => [g, items.filter((x) => x.group === g)]), [items]);
  return (
    <Field label={label}>
      <Select value={cur.id} onValueChange={onChange}>
        <SelectTrigger data-testid={testId}
          className="h-auto py-3 px-4 rounded-xl border-[var(--c-line)] bg-[var(--c-surface)] text-left hover:border-zinc-500 transition-colors focus:ring-[var(--c-orange)]">
          <div className="min-w-0 flex-1 pr-3">
            <div className="flex items-center gap-2"><span className="text-sm font-semibold truncate">{cur.name}</span><Tag>{cur.tag}</Tag></div>
            <p className="text-[11px] text-zinc-500 truncate mt-0.5">{cur.note}</p>
            {meta && <p data-testid={`${testId}-meta`} className="text-[11px] font-mono text-emerald-400 mt-1">{meta(cur)}</p>}
          </div>
        </SelectTrigger>
        <SelectContent className="max-h-[420px] bg-[var(--c-elev)] border-[var(--c-line)] text-white rounded-xl">
          {groups.map(([g, list]) => (
            <SelectGroup key={g}>
              <SelectLabel className="text-[10px] uppercase tracking-[0.14em] text-zinc-500 pt-3">{g}</SelectLabel>
              {list.map((x) => (
                <SelectItem key={x.id} value={x.id} data-testid={`${testId}-option-${x.id}`}
                  className="py-2.5 rounded-lg cursor-pointer focus:bg-[var(--c-hover)] focus:text-white">
                  <div className="flex items-center gap-2"><span className="text-sm font-medium">{x.name}</span><Tag>{x.tag}</Tag></div>
                  <p className="text-[11px] text-zinc-400 mt-0.5">{x.note}</p>
                  {meta && <p data-testid={`${testId}-option-meta-${x.id}`} className="text-[11px] font-mono text-emerald-400 mt-0.5">{meta(x)}</p>}
                </SelectItem>
              ))}
            </SelectGroup>
          ))}
        </SelectContent>
      </Select>
      {hint && <p data-testid={`${testId}-hint`} className="text-xs text-[var(--c-violet)] mt-2">{hint}</p>}
    </Field>
  );
};
